"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _makeStyles = _interopRequireDefault(require("@material-ui/styles/makeStyles"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = (0, _makeStyles.default)(function (theme) {
  return {
    form: {
      display: "flex",
      flexWrap: "wrap",
      gap: theme.spacing(1.5),
      width: "100%",
      "& .mco-form-input:not(.mco-form-textarea):not(.mco-form-file)": {
        flex: "0 0 calc(50% - ".concat(theme.spacing(0.75), "px)")
      },
      "& .mco-form-date": {
        flex: "0 0 calc(50% - ".concat(theme.spacing(0.75), "px)")
      }
    }
  };
});
var _default = styles;
exports.default = _default;